import React from "react";
import "./timelineMobile.css";
import Timeline from '@mui/lab/Timeline';
import TimelineItem from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineOppositeContent from '@mui/lab/TimelineOppositeContent';
import TimelineDot from '@mui/lab/TimelineDot';
import One from '../../../assets/images/one.svg';
import Two from '../../../assets/images/two.svg';
import Three from '../../../assets/images/three.svg';
import Four from '../../../assets/images/four.svg';
import Five from '../../../assets/images/five.svg';

function TimelineMobileHEP() {
    return (
        <div id="timelineMobileProfiler" >
            <Timeline position="alternate" className="timelineMobile">
                <TimelineItem className="timeline-item">
                    <TimelineOppositeContent
                        className="timeline-opposite-content"
                    >
                        <h3>Instant scan</h3>
                        <p>Get instant indicative insights about heart energy and overwork that helps you reflect on your readiness for daily acitivites and rest​</p>
                    </TimelineOppositeContent>
                    <TimelineSeparator>
                        <TimelineConnector sx={{ bgcolor: '#ffffff' }} />
                        <TimelineDot variant="outlined" className="timeline-dot">
                            <img src={One} alt="Profiler" className='numbers-icon' />
                        </TimelineDot>
                        <TimelineConnector className="timeline-connector" />
                    </TimelineSeparator>
                    <TimelineContent className="timeline-content" >
                    </TimelineContent>
                </TimelineItem>
                <TimelineItem className="timeline-item">
                    <TimelineOppositeContent
                        className="timeline-content"
                    >
                    </TimelineOppositeContent>
                    <TimelineSeparator>
                        <TimelineConnector className="timeline-connector" />
                        <TimelineDot variant="outlined" className="timeline-dot">
                            <img src={Two} alt="Profiler" className='numbers-icon' />
                        </TimelineDot>
                        <TimelineConnector className="timeline-connector" />
                    </TimelineSeparator>
                    <TimelineContent className="timeline-opposite-content">
                        <h3>HQI</h3>
                        <p>Generate personalized heart wellbeing profile that serves as an input to lifestyle improvements that you make​</p>
                    </TimelineContent>
                </TimelineItem>
                <TimelineItem className="timeline-item">
                    <TimelineOppositeContent
                        className="timeline-opposite-content"
                    >
                        <h3>Health patterns</h3>
                        <p>We compare your wellness indicators with aggregated population trends to help you track potential changes and stay motivated​</p>
                    </TimelineOppositeContent>
                    <TimelineSeparator>
                        <TimelineConnector className="timeline-connector" />
                        <TimelineDot variant="outlined" className="timeline-dot">
                            <img src={Three} alt="Profiler" className='numbers-icon' />
                        </TimelineDot>
                        <TimelineConnector className="timeline-connector" />
                    </TimelineSeparator>
                    <TimelineContent className="timeline-content" >

                    </TimelineContent>
                </TimelineItem>
                <TimelineItem className="timeline-item">
                    <TimelineOppositeContent
                        className="timeline-content"
                    >

                    </TimelineOppositeContent>
                    <TimelineSeparator>
                        <TimelineConnector className="timeline-connector" />
                        <TimelineDot variant="outlined" className="timeline-dot">
                            <img src={Four} alt="Profiler" className='numbers-icon' />
                        </TimelineDot>
                        <TimelineConnector className="timeline-connector" />
                    </TimelineSeparator>
                    <TimelineContent className="timeline-opposite-content">
                        <h3>Insights</h3>
                        <p>Celebrate your progress, unlock wellness milestones, and stay motivated through comparisons and rewards designed to boost awareness and habit-building​​</p>
                    </TimelineContent>
                </TimelineItem>
               
                    
                <TimelineItem className="timeline-item">
                    <TimelineOppositeContent
                        className="timeline-opposite-content"
                    >
                        <h3>Referrals</h3>
                        <p>Based on your heart wellbeing indicators, we may suggest that you consider speaking with a healthcare professional or undertaking additional assessments in a timely manner​​</p>
                    </TimelineOppositeContent>
                    <TimelineSeparator>
                        <TimelineConnector className="timeline-connector" />
                        <TimelineDot variant="outlined" className="timeline-dot">
                            <img src={Five} alt="Profiler" className='numbers-icon' />
                        </TimelineDot>
                        <TimelineConnector sx={{ bgcolor: '#ffffff' }} />
                    </TimelineSeparator>
                    <TimelineContent className="timeline-content" >

                    </TimelineContent>
                </TimelineItem>
            </Timeline>
        </div>

    );
}

export default TimelineMobileHEP;